import { Router } from 'express';
import { authMiddleware, AuthRequest } from '../../middleware/auth.middleware';
import * as service from './conversations.service';
import { Response, NextFunction } from 'express';
import { getIo } from '../../realtime/socket.bootstrap';

const router = Router();
router.use(authMiddleware);

router.get('/', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    const limit = req.query.limit ? parseInt(req.query.limit as string) : undefined;
    const cursor = req.query.cursor as string | undefined;
    const convs = await service.listConversations(req.user!.sub, limit, cursor);
    res.json({ success: true, data: convs });
  } catch (err) { next(err); }
});

router.post('/dm', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    const conv = await service.getOrCreateDM(req.user!.sub, req.body.userId);
    
    // Force members to join the socket room
    try {
      const io = getIo();
      const room = `conversation:${conv.id}`;
      conv.members.forEach(async (member) => {
        const sockets = await io.in(`user:${member.userId}`).fetchSockets();
        sockets.forEach(socket => socket.join(room));
        io.to(`user:${member.userId}`).emit("CONVERSATION_CREATED", conv);
        io.to(`user:${member.userId}`).emit("CONVERSATION_CREATED", conv);
      });
    } catch (e) {
      console.error('Failed to join sockets to new DM room', e);
    }

    res.json({ success: true, data: conv });
  } catch (err) { next(err); }
});

router.post('/group', async (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    const conv = await service.createGroupConversation(req.user!.sub, req.body.memberIds, req.body.name);
    
    // Force members to join the socket room
    try {
      const io = getIo();
      const room = `conversation:${conv.id}`;
      conv.members.forEach(async (member) => {
        const sockets = await io.in(`user:${member.userId}`).fetchSockets();
        sockets.forEach(socket => socket.join(room));
      });
    } catch (e) {
      console.error('Failed to join sockets to new group room', e);
    }

    res.status(201).json({ success: true, data: conv });
  } catch (err) { next(err); }
});

export default router;
